export default defineNuxtRouteMiddleware((to) => {
return
	if (to.path.startsWith('/initial-necklaces')) {
		return
	}
  	if (to.path.startsWith('/in/') || to.path.startsWith('/in')) {
		let updatedUrl = to.path.replace(/^\/in/, '')
		if(to.path == '/in' || to.path == '/in/') {
			updatedUrl = '/'
		}

		// Replace keywords for US locale
		updatedUrl = updatedUrl
		.replace(/jewellery/gi, 'jewelry')
		.replace(/customise|customised/gi, 'customized')

		// Redirect to the modified path
		return navigateTo({ path: updatedUrl }, { redirectCode: 301 })
  	}
})
